import { render, staticRenderFns } from "./index-company.vue?vue&type=template&id=7261b028&scoped=true"
import script from "./index-company.vue?vue&type=script&lang=js"
export * from "./index-company.vue?vue&type=script&lang=js"
import style0 from "./index-company.vue?vue&type=style&index=0&id=7261b028&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7261b028",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7261b028')) {
      api.createRecord('7261b028', component.options)
    } else {
      api.reload('7261b028', component.options)
    }
    module.hot.accept("./index-company.vue?vue&type=template&id=7261b028&scoped=true", function () {
      api.rerender('7261b028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/index-company.vue"
export default component.exports